import {Dropdown2} from '_metronic/partials'

const SidebarFooter = () => {
  return (
    <div className='app-sidebar-footer flex-column-auto pt-2 pb-6 px-6' id='kt_app_sidebar_footer'>
      {/* overflow MUST stay 'false': with 'true' Metronic re-parents this dropdown to <body>
          (outside React's #root), so the favorite-row React onClick handlers (the delete ✕)
          never fire. Keeping it in-tree fixes that; fixed positioning still lets it overflow
          the sidebar without being clipped. */}
      <button
        type='button'
        className='btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100'
        data-kt-menu-trigger='click'
        data-kt-menu-overflow='false'
        data-kt-menu-placement='top-start'
        title='Favorites'
      >
        <span className='btn-label'>
          <i className='bi bi-star-fill fs-5 me-2'></i>
          Favorites
        </span>
        <i className='bi bi-star-fill fs-2 btn-icon m-0'></i>
      </button>
      <Dropdown2 />
    </div>
  )
}

export {SidebarFooter}
